import { ProductionDeviationForm } from "features/CenterContent/RoleContent/ProductionDeviation/types/formSchema";
import { ProductionDeviationRequest } from "features/CenterContent/RoleContent/ProductionDeviation/types/requestSchema";
import { ProductionDeviationDetailedResponse } from "features/CenterContent/RoleContent/ProductionDeviation/types/responseSchema";
import {
  createBatchFormStateFromResponse,
  createInitialBatchFormState,
} from "features/CenterContent/RoleContent/ProductionDeviation/utils";
import { TimedRequestDuration } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/requestSchema";
import { createRequestDurations } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/transformers";
import { toTrainSerie } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/utils";
import { batchTrainFormToRequestBody } from "features/VehicleSidebar/AffectedTrains/utils/utils";
import { DefaultValues } from "react-hook-form";
import {
  endOfDayCalendarDateTime,
  endOfTodayCalendarDateTime,
  startOfDayCalendarDateTime,
  startOfTodayCalendarDateTime,
} from "shared/utils/dateTimeUtils";

export const defaultForm = (
  trainSeries: string[],
): DefaultValues<ProductionDeviationForm> => ({
  productionDeviationForm: Object.fromEntries(
    trainSeries.map((it) => [
      it,
      {
        selectedTrains: [],
        batchTrainForm: createInitialBatchFormState(it),
      },
    ]),
  ),
  durations: {
    type: "TIMED",
    from_time: startOfTodayCalendarDateTime(),
    to_time: endOfTodayCalendarDateTime(),
  },
});

export const responseToForm = (
  productionDeviationDetailedResponse: ProductionDeviationDetailedResponse,
): DefaultValues<ProductionDeviationForm> => {
  const { trainIds, fromDate, toDate, trainEvents } =
    productionDeviationDetailedResponse;
  const trainSerie = toTrainSerie(trainIds[0]);
  return {
    productionDeviationForm: {
      [trainSerie]: {
        selectedTrains: trainIds.toSorted(),
        batchTrainForm: createBatchFormStateFromResponse(
          trainSerie,
          trainEvents,
        ),
      },
    },
    durations: {
      type: "TIMED",
      from_time: startOfDayCalendarDateTime(fromDate),
      to_time: endOfDayCalendarDateTime(toDate),
    },
  };
};

export const formToRequest = ({
  productionDeviationForm,
  durations,
}: ProductionDeviationForm) => {
  const request: ProductionDeviationRequest = [];

  const trainSeries = Object.keys(productionDeviationForm);
  trainSeries.forEach((trainSerie) => {
    const { batchTrainForm } = productionDeviationForm[trainSerie];
    request.push({
      durations: createRequestDurations(durations) as TimedRequestDuration,
      batchTrainRequest: batchTrainFormToRequestBody({
        [trainSerie]: batchTrainForm,
      }),
    });
  });

  return request;
};
